/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ServeOpenAPIv3Security = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ServeOpenAPIv3Request = {
  /**
   * The ID of the asset to serve
   */
  id: string;
  /**
   * The procect ID that the asset belongs to
   */
  projectId: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ServeOpenAPIv3Response = {
  headers: { [k: string]: Array<string> };
  result: ReadableStream<Uint8Array>;
};

/** @internal */
export type ServeOpenAPIv3Security$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ServeOpenAPIv3Security$outboundSchema: z.ZodMiniType<
  ServeOpenAPIv3Security$Outbound,
  ServeOpenAPIv3Security
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function serveOpenAPIv3SecurityToJSON(
  serveOpenAPIv3Security: ServeOpenAPIv3Security,
): string {
  return JSON.stringify(
    ServeOpenAPIv3Security$outboundSchema.parse(serveOpenAPIv3Security),
  );
}

/** @internal */
export type ServeOpenAPIv3Request$Outbound = {
  id: string;
  project_id: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ServeOpenAPIv3Request$outboundSchema: z.ZodMiniType<
  ServeOpenAPIv3Request$Outbound,
  ServeOpenAPIv3Request
> = z.pipe(
  z.object({
    id: z.string(),
    projectId: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectId: "project_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function serveOpenAPIv3RequestToJSON(
  serveOpenAPIv3Request: ServeOpenAPIv3Request,
): string {
  return JSON.stringify(
    ServeOpenAPIv3Request$outboundSchema.parse(serveOpenAPIv3Request),
  );
}

/** @internal */
export const ServeOpenAPIv3Response$inboundSchema: z.ZodMiniType<
  ServeOpenAPIv3Response,
  unknown
> = z.pipe(
  z.object({
    Headers: z._default(z.record(z.string(), z.array(z.string())), {}),
    Result: z.custom<ReadableStream<Uint8Array>>(x =>
      x instanceof ReadableStream
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "Headers": "headers",
      "Result": "result",
    });
  }),
);

export function serveOpenAPIv3ResponseFromJSON(
  jsonString: string,
): SafeParseResult<ServeOpenAPIv3Response, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ServeOpenAPIv3Response$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ServeOpenAPIv3Response' from JSON`,
  );
}
